'use client'

import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { Section, SectionHeading } from '@/components/platform/v2/Section'
import { PageCta, PageHero } from '@/components/platform/v2/PageEdge'
import { PROOF } from '@/data/platform'

const Achievements = () => (
    <div className="vcentre-public pt-24 sm:pt-28 md:pt-32">
        <PageHero
            eyebrow="Компания и признание"
            title="Достижения проекта"
            text={<p>Наши достижения — результат доверия клиентов. Каждый проект, который работает на платформе, двигает нас вперёд.</p>}
            visual={
                <img
                    src={'/assets/images/platform/achievements-mascot-hero.png'}
                    alt="Маскот VCENTRE.IT с табличкой и рукопожатием — символ доверия клиентов"
                    width={1254}
                    height={1254}
                    loading="eager"
                    className="w-full max-w-[330px] animate-float drop-shadow-[0_30px_60px_rgba(0,0,0,0.6)] sm:max-w-[420px]"
                />
            }
        />

        <Section tone="quiet">
            <SectionHeading align="left" title="Подтверждённые факты" />
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
                {PROOF.map((p) => (
                    <a
                        key={p.title}
                        href={p.href}
                        target="_blank"
                        rel="noreferrer"
                        className="surface surface-hover flex items-start justify-between gap-4"
                    >
                        <div>
                            <p className="text-base font-bold text-foreground">{p.title}</p>
                            <p className="mt-1 text-xs text-muted-foreground">{p.org}</p>
                        </div>
                        <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-primary" />
                    </a>
                ))}
            </div>
        </Section>

        <Section>
            <PageCta
                title="Мероприятия и публичная активность"
                text={<p>Календарь встреч, форумов и онлайн-эфиров с командой платформы — в разделе мероприятий.</p>}
                visual={
                    <img
                        src={'/assets/images/platform/achievements-mascot-cta.png'}
                        alt="Маскот VCENTRE.IT с планшетом «Партнёрство» — формы сотрудничества"
                        width={1312}
                        height={1199}
                        loading="lazy"
                        className="w-full max-w-[260px] drop-shadow-[0_24px_48px_rgba(0,0,0,0.55)]"
                    />
                }
                actions={
                    <>
                        <Link href="/platform/events" className="btn-primary">
                            Мероприятия
                        </Link>
                        <Link href="/platform/company" className="btn-ghost">
                            О компании
                        </Link>
                        <Link href="/signin?source=achievements" className="btn-link">
                            Посмотреть, что мы можем собрать для вас
                        </Link>
                    </>
                }
            />
        </Section>
    </div>
)

export default Achievements
